import { FormValidator, type FormValidatorConfig, type FormValidatorSettings } from '../models';
import { isEmpty } from '../utils';

export interface MinValidatorSettings extends FormValidatorSettings {
  min: number;
  equalEnabled: boolean;
  formatMin?: (min: number) => string;
  formatBeforeValidation?: (value: any) => number;
}

export type MinValidatorConfig = FormValidatorConfig<MinValidatorSettings>;

export class MinValidator extends FormValidator<MinValidatorSettings> {
  constructor() {
    super();
    this._name = 'min';
    this._settings = {
      min: 0,
      equalEnabled: true,
      invalidMessage: 'form.validator.min.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const formattedValue = this._settings.formatBeforeValidation ? this._settings.formatBeforeValidation(value) : value;

    this._valid = this._settings.equalEnabled
      ? this._settings.min <= formattedValue
      : this._settings.min < formattedValue;

    if (!this._valid) {
      let minString = this._settings.min.toString();
      if (this._settings.formatMin) {
        minString = this._settings.formatMin(this._settings.min);
      }

      this.addMessage(this._settings.invalidMessage, 'error', {
        min: minString
      });
    }
  }
}
